"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const BSRRewindClock = createSVGIcon(
  <path
    d="M3 12a9 9 0 1 0 1.516-5M7.5 6.75 4.516 7V3.875M12 7.75V12h4"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
  />,
  "BSRRewindClock",
  {
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
